// Angular
import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {CdkDrag} from '@angular/cdk/drag-drop';

// Material library
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

// Local library
import { SanitizerPipe } from '@amwager/util';

@Component({
  selector: 'feature-mat-live-video',
  templateUrl: './live-video.component.html',
  styleUrls: ['./live-video.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    SanitizerPipe,
    CdkDrag
  ]
})
export class LiveVideoComponent implements OnInit {

  liveVideoUrl: string = '';

  constructor(
    private dialogRef: MatDialogRef<LiveVideoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.liveVideoUrl = data;
  }

  /**
   * Init on load
   * @returns {void}
   */
  ngOnInit() {
    null;
  }

  /**
   * Close dialog
   * @returns {void}
   */
  closeDialog(): void {
    this.dialogRef.close();
  }
}
